import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("crn_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

export function formatApiError(err, fallback = "Something went wrong. Please try again.") {
    const detail = err?.response?.data?.detail;
    if (detail == null) return err?.message || fallback;
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
    if (detail && typeof detail === "object") return detail.message || JSON.stringify(detail);
    return String(detail);
}

export function apiErrorDetail(err) {
    return err?.response?.data?.detail;
}

export default api;
